<template>
  <div class="UIModalActions">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss">
.UIModalActions {
  text-align: end;
  background: $color-white;
  // border-top: 1px solid $color-neutral-10;
  padding: var(--padding-actions, 1rem 1.5rem);
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
</style>
